import React from "react";
import { FaCalendarTimes, FaRedo } from "react-icons/fa";

function SharedEventsEmptyState({ onReset }) {
  return (
    <div className="mt-6 rounded-[2rem] border border-dashed border-slate-300 bg-white p-8 text-center shadow-xl shadow-slate-200/50 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-white/60">
        <FaCalendarTimes className="text-2xl" />
      </div>

      <h2 className="mt-5 font-titre text-2xl font-bold text-slate-950 dark:text-white">
        Aucun événement trouvé
      </h2>

      <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-7 text-slate-500 dark:text-white/50">
        Aucun événement partagé ne correspond aux filtres sélectionnés. Tu peux
        élargir la recherche ou revenir à la vue des événements à venir.
      </p>

      <button
        type="button"
        onClick={onReset}
        className="mt-6 inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-2 text-sm font-bold text-white transition hover:-translate-y-0.5 dark:bg-white dark:text-slate-950"
      >
        <FaRedo />
        Réinitialiser les filtres
      </button>
    </div>
  );
}

export default SharedEventsEmptyState;